export const enecoImageTokens = {
  imageSplitviewBorderRadii: '{{ GRID * 4 }}px',
};
